import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentService } from '../../services/content/content.service';

@Pipe({
  name: 'contentActivity'
})
export class ActivityPipe implements PipeTransform {

  constructor(
    private contentService: ContentService
  ) {
  }

  transform(entry: Models.ContentEntry, parent = null): Models.ActivityEntry | Models.ContentActivityDay {
    if (!entry) {
      return null;
    }

    if (entry.related && entry.related.entries && entry.related.entries.length > 0 && !entry.detail.forcePipe) {
      const days: Models.ContentActivityDay[] = [];

      for (const item of entry.related.entries) {
        const contentEntry = this.contentService.getEntry(item.id);
        const day = this.generateDay(contentEntry);
        if (day) {
          days.push(day);
        }
      }
      const activityEntry = new Models.ActivityEntry();
      activityEntry.populateFromJSON({ days });
      return activityEntry;
    }

    return this.generateDay(entry);
  }

  private generateDay(entry: Models.ContentEntry): Models.ContentActivityDay {
    if (!entry || !entry.detail) {
      return null;
    }
    if (!this.contentService.isValid(entry)) {
      return null;
    }

    const activities: Models.ActivityContent[] = [];
    if (entry.detail.activities) {
      for (const rawActivity of entry.detail.activities) {
        const activity = new Models.ActivityContent();
        activity.populateFromJSON({
          title: rawActivity.title,
          time: rawActivity.time,
          endTime: rawActivity.endTime,
          description: rawActivity.content
        });
        activities.push(activity);
      }
    }

    const day = new Models.ContentActivityDay();
    day.populateFromJSON({
      sourceId: entry._id,
      date: entry.detail.date,
      activities
    });

    return day;
  }

}
